import { render, staticRenderFns } from "./page-upload.vue?vue&type=template&id=af4db722&scoped=true&"
import script from "./page-upload.vue?vue&type=script&lang=js&"
export * from "./page-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4db722",
  null
  
)

export default component.exports